/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Checkbox,
} from 'antd';
import dayjs from 'dayjs';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import { INFINITE_EXPIRY_DATE, QUANTITY, DEFAULT_CUR_ROUND_OFF } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import ViewBatchCustomFields from '../../../../../Common/ViewBatchCustomFields';
/**
 * @param withApproval
 */
class BatchSelectorCN extends Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);
    this.state = {
      batchColumns: [
        {
          title: '',
          render: (text, record) => {
            const { onToggleBatch, itemsRow } = this.props;
            return (
              <Checkbox checked={record?.batch_in_use} onChange={() => onToggleBatch(record, itemsRow)} disabled={Number(record?.consumed_qty) - Number(record?.cn_gen_qty) <= 0} />
            );
          },
        },
        {
          title: 'Batch#',
          render: (text, record) => {
            const { org, productInfo } = this.props;
            const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
            return (
              <div>
                <H3Text text={record?.custom_batch_number || record?.batch_number} style={{ fontWeight: '500' }} />
                <div className="table-subscript">
                  {record?.lot_number && batchConfig?.lot_number_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Lot#</span>
                        {' '}
                        {record?.lot_number}
                      </span>
                    )}
                    />
                  )}
                  {record?.ar_number && batchConfig?.ar_number_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>AR#</span>
                        {' '}
                        {record?.ar_number}
                      </span>
                    )}
                    />
                  )}
                  {record?.batch_barcode && batchConfig?.batch_barcode_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Barcode</span>
                        {' '}
                        {record?.batch_barcode}
                      </span>
                    )}
                    />
                  )}
                  {record?.batch_inward_date && batchConfig?.batch_inward_date_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Inward Date</span>
                        {' '}
                        {dayjs(record?.batch_inward_date).format('DD MMM, YY')}
                      </span>
                    )}
                    />
                  )}
                  {record?.roll_no && batchConfig?.roll_no_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Roll No#</span>
                        {' '}
                        {record?.roll_no}
                      </span>
                    )}
                    />
                  )}
                  {record?.mrp > 0 && batchConfig?.mrp_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>MRP</span>
                        {' '}
                        {this.props.MONEY(record?.mrp)}
                      </span>
                    )}
                    />
                  )}
                  {record?.selling_price > 0 && batchConfig?.selling_price_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>SP</span>
                        {' '}
                        {this.props.MONEY(record?.selling_price)}
                      </span>
                    )}
                    />
                  )}
                  {record?.landed_cost > 0 && batchConfig?.landed_cost_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Landed Cost</span>
                        {' '}
                        {this.props.MONEY(record?.landed_cost)}
                      </span>
                    )}
                    />
                  )}
                  {record?.freight_cost > 0 && batchConfig?.freight_cost_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Freight Cost</span>
                        {' '}
                        {this.props.MONEY(record?.freight_cost)}
                      </span>
                    )}
                    />
                  )}
                  {record?.other_cost > 0 && batchConfig?.other_cost_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Other Cost</span>
                        {' '}
                        {this.props.MONEY(record?.other_cost)}
                      </span>
                    )}
                    />
                  )}
                  {record?.margin > 0 && batchConfig?.margin_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Margin</span>
                        {' '}
                        {parseFloat(Number(record?.margin).toFixed(DEFAULT_CUR_ROUND_OFF))}
                        %
                      </span>
                    )}
                    />
                  )}
                  {record?.brand && batchConfig?.brand_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Brand</span>
                        {' '}
                        {record?.brand}
                      </span>
                    )}
                    />
                  )}
                  {record?.mfg_batch_no && batchConfig?.mfg_batch_no_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Mfg batch #</span>
                        {' '}
                        {record?.mfg_batch_no}
                      </span>
                    )}
                    />
                  )}
                  {record?.manufacturing_date && batchConfig?.manufacturing_date_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Mfg Date</span>
                        {' '}
                        {Helpers.batchDateFormatter(record?.manufacturing_date, productInfo?.manufacturing_date_format)}
                      </span>
                    )}
                    />
                  )}
                  {record?.next_qc_date && batchConfig?.next_qc_date_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Next QC Date</span>
                        {' '}
                        {dayjs(record?.next_qc_date).format('DD MMM, YY')}
                      </span>
                    )}
                    />
                  )}
                  {record?.last_qc_date && batchConfig?.last_qc_date_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Last QC Date</span>
                        {' '}
                        {dayjs(record?.last_qc_date).format('DD MMM, YY')}
                      </span>
                    )}
                    />
                  )}
                </div>
                {record?.reservation_details && (
                  <div className="status-tag reservation-tag">
                    Reserved
                  </div>
                )}
              </div>
            );
          },
          width: '180px',
        },
        {
          title: 'Expiry',
          width: '80px',
          render: (text, record) => {
            const { productInfo } = this.props;
            return record?.expiry_date !== INFINITE_EXPIRY_DATE ? (Helpers.batchDateFormatter(record?.expiry_date, productInfo?.expiry_date_format)) : '-'
          },
        },
        {
          title: 'Shelf Life',
          render: (text, record) => {
            const { expiryDays } = this.props;
            const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
            let shelfLife = 0;
            if (dayjs().isSameOrBefore(expiryMoment)) {
              shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
            }
            let shelfLifePct = Math.round(((shelfLife / expiryDays) * 100));
            if (record?.expiry_date === INFINITE_EXPIRY_DATE) shelfLifePct = 100;
            if (expiryDays < 0) {
              return (
                <div style={{ width: '220px' }}>
                  No Expiry (100%)
                </div>
              );
            }
            return (
              (
                <div className="batch-shelf-life">
                  <div
                    className="progress-line__wrapper"
                    style={{
                      width: '120px',
                      backgroundColor: shelfLifePct < 25 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)',
                    }}
                  >
                    <div
                      className="progress-line"
                      style={{
                        width: `${shelfLifePct > 100 ? 100 : shelfLifePct}%`,
                        backgroundColor: shelfLifePct < 25 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A',
                      }}
                    />
                  </div>
                  <span>
                    {record?.expiry_date === INFINITE_EXPIRY_DATE ? 'NA' : `${shelfLife} Days (${shelfLifePct}%)`}
                  </span>
                </div>
              )
            );
          },
        },
        {
          title: 'Cost Price',
          render: (text, record) => (record?.cost_price ? this.props.MONEY(record?.cost_price) : '-'),
        },
        {
          title: 'Invoiced Quantity',
          render: (text, record) => {
            const { uomInfo } = this.props;
            return (
              <div>{`${QUANTITY(record?.consumed_qty || 0, uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
            );
          },
        },
        {
          title: 'Returned Quantity',
          render: (text, record) => {
            const { uomInfo } = this.props;
            return (
              <div>{`${QUANTITY(record?.cn_gen_qty || 0, uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
            );
          },
        },
        {
          title: 'Batch Quality',
          render: (text, record) => (
            <div className="qr__status" style={{ backgroundColor: record?.is_rejected_batch ? '#ee2232' : '#2fbc6e' }}>
              {record?.is_rejected_batch ? 'Bad' : 'Good'}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'To Be Returned',
          render: (text, record) => {
            const { uomInfo, creditNoteWithReturnedQyt, fromCreditNote } = this.props;
            const quantityToUse = creditNoteWithReturnedQyt ? record?.returned_quantity : record?.quantity;
            return (
              <div style={{ color: fromCreditNote ? 'green' : quantityToUse ? 'red' : 'black' }}>{`${fromCreditNote ? '+' : quantityToUse ? '-' : ''}${QUANTITY(quantityToUse || '0', uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
            );
          },
        },
        {
          title: 'Custom Fields',
          render: (record) => (<ViewBatchCustomFields customFields={record?.custom_fields} />),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        }
      ],
    };
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      batches, itemsRow, updateData, data, user, isReturnSlip,
    } = this.props;
    const {
      batchColumns,
    } = this.state;
    const copyData = JSON.parse(JSON.stringify(data));
    const enabledWarehouseLocations = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;
    return (
      <div className="batch-selector-wrapper">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
        }}
        >
          <H3Text text="Available Stock Batches" className="batch-selector-title" />

          {!isReturnSlip && (<Checkbox
            checked={!!itemsRow.updateStock}
            onChange={() => {
              const updatedData = copyData.map((obj) => {
                if (obj.key === itemsRow.key) {
                  return { ...obj, updateStock: !itemsRow.updateStock };
                }
                return obj;
              });
              updateData(updatedData);
            }}
          >
            Return to Stock
          </Checkbox>)}
        </div>
        <Table
          size="small"
          columns={enabledWarehouseLocations ? [...batchColumns, {
            title: 'Location',
            render: (text, record) => (record?.inventory_location_path),
            responsive: ['sm', 'md', 'lg', 'xxl'],
          }] : batchColumns}
          dataSource={batches}
          pagination={false}
          bordered
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  org: UserReducers.org,
});

const mapDispatchToProps = (dispatch) => ({

});

BatchSelectorCN.propTypes = {
  history: PropTypes.func,
  itemsRow: PropTypes.any,
  batches: PropTypes.any,
  uomInfo: PropTypes.any,
  noCalculations: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BatchSelectorCN));
